import {RefreshBanner} from "../../components/banners/RefreshBanner/RefreshBanner";

export const PublicModals: React.FC = () => {
  return <RefreshBanner />;
};
